import { SelectedSlot } from '@customTypes/Availabilities'
import { addMinutes, format } from 'date-fns'

export const getTimeslotHourRange = (locale: Locale, selectedSlot?: SelectedSlot, durationMin?: number) => {
  if (!durationMin || !selectedSlot?.originalStartTimestamp) {
    return
  }
  const originalStartTimestamp = new Date(selectedSlot.originalStartTimestamp)
  const endTimestamp = addMinutes(originalStartTimestamp, durationMin)

  return `${selectedSlot.time} - ${format(endTimestamp, 'HH:mm', { locale })}`
}

export default getTimeslotHourRange
